import PropTypes from "prop-types"
import { Box, Button, IconButton } from "@mui/material"
import { AutoMode, Block } from "@mui/icons-material"
import AnimatedLoadingButton from "./animated-loading-button"
import OPTooltip from "components/material/tooltip"

export default function QueryActions({
  question,
  onClear,
  onAsk,
  onAbort,
  disabled,
  isLoading,
}) {
  const isDisabled = !question || disabled
  return (
    <Box className="actions">
      {isLoading && <OPTooltip title="Cancel">
        <IconButton
          variant="outlined"
          color="error"
          onClick={onAbort}
        >
          <Block />
        </IconButton>
      </OPTooltip>}
      <Button
        variant="text"
        onClick={onClear}
        disabled={isDisabled}
      >
        Clear
      </Button>
      {isLoading ? <AnimatedLoadingButton />
        : <Button
            variant="contained"
            color="primary"
            startIcon={<AutoMode size="small" className="ask-icon" />}
            onClick={onAsk}
            disabled={isDisabled}
        >
          Ask
        </Button>}
    </Box>
  )
}

QueryActions.propTypes = {
  question: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired,
  onAsk: PropTypes.func.isRequired,
  onAbort: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
}
